// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { getProjectURLLinks } from '@/project/api/get-project-url-links';
import { useQuery } from '@tanstack/react-query';

interface UseProjectURLLinksOptions {
  /** The key of the project to fetch URL links for */
  projectKey: string;
}

/**
 * Hook to fetch URL links associated with a project.
 * Uses a regular query (not suspense) to allow graceful error handling
 * without crashing the entire page.
 *
 * @param options - Options including the project key
 * @returns The URL links, loading state, error state, and query methods
 */
export function useProjectURLLinks(options: UseProjectURLLinksOptions) {
  const { data, isLoading, isError, error, refetch, ...query } = useQuery({
    queryKey: ['project', options.projectKey, 'url-link'],
    queryFn: () => getProjectURLLinks(options.projectKey),
  });

  return {
    urlLinks: data?.data ?? [],
    isLoading,
    isError,
    error,
    refetch,
    ...query,
  };
}
